module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('table', {
    staticClass: "el-table"
  }, [_c('thead', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Sharer")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Percent")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Sites")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sharers), function(sharer, index) {
    return _c('tr', [_c('td', [_c('i', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(sharer.name))]), _vm._v(" "), _c('small', [_vm._v("["), _c('span', {
      class: sharer.type === 'Sharer' ?
        'text-success' : 'text-info'
    }, [_vm._v("\n              " + _vm._s(sharer.type) + "\n            ")]), _vm._v("]\n          ")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.formatNumber(sharer.percent, 2)))]), _vm._v("%")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.formatNumber(sharer.sites, 0)))])])])
  }), 0)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a2eb232"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/sharers/WaysTable.vue
// module id = 1678
// module chunks = 0